import React from 'react'
import { Container, Accolades, Fsa, A, NavList, NavItem, NavLink, Contact } from './styles'
import fsa from '../../../images/fsa.jpeg'
import Logo from '../../logo'
import { P } from '../../typography'

const Upper = () => (
  <Container>
    <Contact>
      <Logo />
      <P white><A href="tel:+441983402773">01983 402773</A></P>
      <P white><A href="mailto:info@chesterlodge.com">info@chesterlodge.com</A></P>
      <P white>7 Beachfield Road, Sandown, Isle of Wight, P036 8NA</P>
    </Contact>
    <Accolades>
      <a href="https://ratings.food.gov.uk/business/en-GB/542166/Chester-Lodge-Isle-Of-Wight" target="_blank" rel="noopener noreferrer">
        <Fsa src={fsa} alt="Food Hygeine Rating - Very Good" />
      </a>
    </Accolades>
    <NavList>
      <NavItem>
        <NavLink to="/" activeClassName="active">Home</NavLink>
      </NavItem>

      <NavItem>
        <NavLink to="/rooms-and-facilities" activeClassName="active">Rooms and Facilities</NavLink>
      </NavItem>

      <NavItem>
        <NavLink to="/guest-comments" activeClassName="active">Guest Comments</NavLink>
      </NavItem>

      <NavItem>
        <NavLink to="/contact-us" activeClassName="active">Contact Us</NavLink>
      </NavItem>
    </NavList>
  </Container>
)

export default Upper
